import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vue-material-design-icons/styles.css'
import Toolbar from './components/core/Toolbar.vue'
import Navigation from './components/core/NavigationDrawer.vue'
import Breadcrumbs from './components/core/Breadcrumbs.vue'
import axios from 'axios'
import Cookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(VueSweetalert2)
Vue.use(Cookies)
Vue.component('toolbar', Toolbar)
Vue.component('navigation', Navigation)
Vue.component('breadcrumbs', Breadcrumbs)

axios.defaults.baseURL = process.env.VUE_APP_RUTA_API // 'http://creditoria.local/'
// axios.defaults.baseURL = 'https://simulador-credito-bend.precacreditaria.com/'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
